import { render } from "./ProductToCustomerPrices.vue?vue&type=template&id=ad0b73b0&ts=true"
import script from "./ProductToCustomerPrices.vue?vue&type=script&lang=ts"
export * from "./ProductToCustomerPrices.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__